import { useEffect, useState } from "react";
import {
  deleteUser,
  createUser,
  editUser,
} from "../../services/user-management";
import { useTableContext } from "../../context/tableContext";
import { useFileUploadContext } from "../../context/fileUploadContext";
import { getPermissionAccess, getPermissions } from "../../utils";
import { toast } from "react-toastify";

const data: any = [
  { index: 1, status: ["Ordered", "New"] },
  { index: 2, status: ["InWareHouse"] },
  { index: 3, status: ["Shipped"] },
  {
    index: 4,
    status: ["Registered", "Commissioned", "Installed", "Connected"],
  },
  { index: 5, status: ["Active"] },
  { index: 6, status: ["RMA"] },
];

export const getStatus = (accordian: any) => {
  const finalAccordianStatus = data.filter(
    (item: any) => item.index === accordian
  )[0]?.status;
  return finalAccordianStatus;
};

export default function useUserHook() {
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);

  const handleClickOpen = (row: any) => {
    setEditingRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditingRow(null);
  };
  const [permissionAccess, setPermissionAccess] = useState<any>({});

  const {
    setSelectedRows,
    setSelectedRowsWithPage,

    selectedRows,
    selectedRowsWithPage,

    updatedTableData,
    setResultCount,
    setPage,
    nonEditMode,
    setNonEditMode,
    setEditMode,
    editMode,
    dataList,
    pagination,
    setPagination,
    getData,
  } = useTableContext();
  const { successWindow, setSuccessWindow, failedWindow, setFailedWindow } =
    useFileUploadContext();

  const [editingRow, setEditingRow] = useState<any>(null);
  const [editedValues, setEditedValues] = useState<any>({});
  const [permissions, setPermissions] = useState<any>([]);
  const CALLBACK_URL = process.env.REACT_APP_CALLBACK_URL as string;

  useEffect(() => {
    const url = window.location.href;
    const permission = getPermissions(url);
    setPermissions(permission);
  }, []);

  const createNewUser = () => {
    setNonEditMode(true);
    setEditMode(false);
  };
  const deleteUserdata = async () => {
    const response: any = await deleteUser(
      editingRow?.userName,
      editingRow?.userId
    );
    if (response.returnCode === 200) {
      setSuccessWindow({
        ...successWindow,
        status: true,
        message: response?.message,
      });
      getData();
      // setOpen(false);
      handleClose();
    } else {
      setFailedWindow({
        ...failedWindow,
        status: true,
        message: response?.message,
      });
    }
  };
  useEffect(() => {
    const access = getPermissionAccess(permissions);
    setPermissionAccess(access);
  }, [permissions]);

  const onPageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPagination((currentData: any) => {
      return {
        ...currentData,
        page: newPage - 1,
      };
    });
  };

  const onRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPagination((currentData: any) => {
      return {
        ...currentData,
        page: 0,
        rowsPerPage: parseInt(event.target.value),
      };
    });
  };

  const handleSubmit = async (values: any) => {
    let roleAction = "add";
    let filterRole = [];
    if (editMode) {
      let length = 0;
      const removeSystemRole = editingRow?.role?.filter(
        (role: any) => role !== "SYSTEM_ROLE"
      );
      length = removeSystemRole?.length;
      if (length === 2) {
        roleAction = "remove";
        const filter = removeSystemRole?.filter((role: any) => {
          return !values?.role?.includes(role);
        });
        filterRole = filter;
      } else {
        const filter = values?.role?.filter((role: any) => {
          return !removeSystemRole?.includes(role);
        });
        filterRole = filter;
        roleAction = "add";
      }
    }

    const payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      userName: values.userName,
      emailAddress: values.email,
      mobileNumber: values.phone,
      userStatus: values.status,
      role: editMode ? filterRole : values.role, //EVES-1713 adding multiple roles to the user while editing or creating
      createdBy: "adminuser@dynachrg.com",
      modifiedBy: "adminuser@dynachrg.com",
      userId: editingRow?.userName || "",
      callbackurl: editingRow ? "" : CALLBACK_URL,
      ...(editMode && { roleAction }),
      //EVES-1965 - In case of locked status, send user data and migrate to active status
      ...(editingRow?.userStatus === "Locked" &&
        values?.status === "Active" && {
        UserUnlock: true,
      }),
    };

    if (editMode) {
      const editResponse: any = await editUser({ payload });
      if (editResponse.returnCode === 200) {
        setSuccessWindow({
          ...successWindow,
          status: true,
          message: "User edited successfully!",
        });
        getData();
        setEditMode(false);
        setNonEditMode(false);
      } else {
        toast.error("Failed to update user.");
      }
    } else {
      const response: any = await createUser({ payload });
      if (response.returnCode === 200) {
        setSuccessWindow({
          ...successWindow,
          status: true,
          message: "User created successfully!",
        });
        getData(); // Refresh the data list after creation
        setEditMode(false);
        setNonEditMode(false);
      } else {
        setFailedWindow({
          ...failedWindow,
          status: true,
          message: "Failed to create user or User already exists",
        });
      }
    }
  };

  return {
    dataList,
    pagination,
    setPagination,
    setPage,
    onPageChange,
    onRowsPerPageChange,

    loading,

    selectedRows,
    setSelectedRows,
    editingRow,
    setEditedValues,
    nonEditMode,
    setNonEditMode,
    editedValues,
    setEditingRow,
    deleteUserdata,
    getData,

    selectedRowsWithPage,
    handleSubmit,
    updatedTableData,
    setResultCount,

    setSelectedRowsWithPage,
    createNewUser,
    editMode,
    setEditMode,
    handleClickOpen,
    open,
    handleClose,
    setLoading,
    permissions,
    permissionAccess,
  };
}
